import { Component, Input, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function AbpNavMenuComponent_ng_container_0_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵelement(1, "nav-menu-Item", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const menu_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", menu_r2.isActive ? "active" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("node", menu_r2);
} }
function AbpNavMenuComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "ul", 2);
    ɵngcc0.ɵɵtemplate(3, AbpNavMenuComponent_ng_container_0_li_3_Template, 2, 2, "li", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.navMenuModel.menuList);
} }
function NavMenuItemComponent_ng_container_0_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 4);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.node.icon);
} }
function NavMenuItemComponent_ng_container_0_i_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 4);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.getCaretClass(ctx_r2.node));
} }
function NavMenuItemComponent_ng_container_0_ng_container_6_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 7);
    ɵngcc0.ɵɵelement(1, "nav-menu-Item", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const submenuItem_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", submenuItem_r5.isActive ? "active" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("node", submenuItem_r5);
} }
function NavMenuItemComponent_ng_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ul", 5);
    ɵngcc0.ɵɵtemplate(2, NavMenuItemComponent_ng_container_0_ng_container_6_li_2_Template, 2, 2, "li", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "ul_child_subMenu", ctx_r3.node.code, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.node.childNodes);
} }
function NavMenuItemComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 1);
    ɵngcc0.ɵɵlistener("click", function NavMenuItemComponent_ng_container_0_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.menuClick(ctx_r6.node); });
    ɵngcc0.ɵɵtemplate(2, NavMenuItemComponent_ng_container_0_i_2_Template, 1, 1, "i", 2);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵtemplate(5, NavMenuItemComponent_ng_container_0_i_5_Template, 1, 1, "i", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, NavMenuItemComponent_ng_container_0_ng_container_6_Template, 3, 2, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("name", "a_olm_", ctx_r0.node.code, "");
    ɵngcc0.ɵɵpropertyInterpolate1("id", "a_olm_", ctx_r0.node.code, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.node.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.node.displayText, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasChildNodes(ctx_r0.node));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasChildNodes(ctx_r0.node) && ctx_r0.node.isExapand);
} }
const _c0 = ".nav-item-link[_ngcontent-%COMP%], .transparent-border[_ngcontent-%COMP%], .transparent-button[_ngcontent-%COMP%]{border-style:solid;border-color:transparent}.abp-side-nav[_ngcontent-%COMP%], .no-left-padding[_ngcontent-%COMP%], .no-side-span[_ngcontent-%COMP%]{padding-left:0}.abp-side-nav[_ngcontent-%COMP%], .no-right-padding[_ngcontent-%COMP%], .no-side-span[_ngcontent-%COMP%]{padding-right:0}.abp-side-nav[_ngcontent-%COMP%], .no-top-padding[_ngcontent-%COMP%]{padding-top:0}.nav-item-link[_ngcontent-%COMP%], .transparent-button[_ngcontent-%COMP%]{background-color:transparent}.abp-side-nav[_ngcontent-%COMP%]{width:100%;background-color:#17a2b8;color:#fff;text-align:left}.nav-item-group[_ngcontent-%COMP%], .nav-item-group-child[_ngcontent-%COMP%]{list-style-type:none;line-height:2.5;padding-left:1px;padding-top:1px;padding-bottom:1px}.nav-item[_ngcontent-%COMP%]{padding-left:1px;padding-top:1px;padding-bottom:1px;border-bottom-style:groove;border-bottom-color:#fff}.nav-item-child[_ngcontent-%COMP%]{padding-left:2px;border-bottom-color:transparent!important}.nav-item-link[_ngcontent-%COMP%]{width:100%;text-align:left;color:#fff}.nav-item-link[_ngcontent-%COMP%]   .nav-item-icon[_ngcontent-%COMP%]{float:right;padding-right:1px!important;margin-right:0!important;vertical-align:central}";
class AbpMenuItemModel {
    //#endregion model properties
    //#region readonly properties
    //#endregion readonly properties
    //#region constructor
    constructor() {
        this.childNodes = [];
        this.isExapand = false;
    }
}
if (false) {
    /** @type {?} */
    AbpMenuItemModel.prototype.code;
    /** @type {?} */
    AbpMenuItemModel.prototype.displayText;
    /** @type {?} */
    AbpMenuItemModel.prototype.url;
    /** @type {?} */
    AbpMenuItemModel.prototype.icon;
    /** @type {?} */
    AbpMenuItemModel.prototype.isActive;
    /** @type {?} */
    AbpMenuItemModel.prototype.isExapand;
    /** @type {?} */
    AbpMenuItemModel.prototype.childNodes;
    /** @type {?} */
    AbpMenuItemModel.prototype.clickHandler;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
/**
 * @record
 */
function AbpMenuConfigModel() { }
if (false) {
    /** @type {?} */
    AbpMenuConfigModel.prototype.expandStateIcon;
    /** @type {?} */
    AbpMenuConfigModel.prototype.collapseStateIcon;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class AbpNavMenuModel {
    //#endregion model properties
    //#region constructor
    constructor() {
        this.menuList = [];
    }
}
if (false) {
    /** @type {?} */
    AbpNavMenuModel.prototype.menuList;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpNavMenuComponent {
    //#endregion input properties
    //#region model properties
    //#endregion model properties
    //#region constructor
    constructor() {
        //#region input properties
        this.show = true;
        this.navMenuModel = new AbpNavMenuModel();
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
    }
}
AbpNavMenuComponent.ɵfac = function AbpNavMenuComponent_Factory(t) { return new (t || AbpNavMenuComponent)(); };
AbpNavMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpNavMenuComponent, selectors: [["abp-nav-menu"]], inputs: { show: "show", navMenuModel: "navMenuModel" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "abp-side-nav"], ["name", "ul_parent_menu", "id", "ul_parent_menu", 1, "nav-item-group"], ["name", "li_parent_menu", "id", "li_parent_menu", "class", "nav-item", 3, "ngClass", 4, "ngFor", "ngForOf"], ["name", "li_parent_menu", "id", "li_parent_menu", 1, "nav-item", 3, "ngClass"], [3, "node"]], template: function AbpNavMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AbpNavMenuComponent_ng_container_0_Template, 4, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgClass, NavMenuItemComponent]; }, styles: [_c0] });
/** @nocollapse */
AbpNavMenuComponent.ctorParameters = () => [];
AbpNavMenuComponent.propDecorators = {
    show: [{ type: Input }],
    navMenuModel: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpNavMenuComponent, [{
        type: Component,
        args: [{
                selector: 'abp-nav-menu',
                template: "<ng-container *ngIf=\"show\">\r\n  <div class=\"abp-side-nav\">\r\n    <ul class=\"nav-item-group\"\r\n        name=\"ul_parent_menu\"\r\n        id=\"ul_parent_menu\">\r\n      <li name=\"li_parent_menu\"\r\n          id=\"li_parent_menu\"\r\n          class=\"nav-item\"\r\n          [ngClass]=\"menu.isActive ? 'active' : ''\"\r\n          *ngFor=\"let menu of navMenuModel.menuList; let i=index;\">\r\n        <nav-menu-Item [node]=\"menu\"></nav-menu-Item>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</ng-container>\r\n\r\n",
                styles: [".nav-item-link,.transparent-border,.transparent-button{border-style:solid;border-color:transparent}.abp-side-nav,.no-left-padding,.no-side-span{padding-left:0}.abp-side-nav,.no-right-padding,.no-side-span{padding-right:0}.abp-side-nav,.no-top-padding{padding-top:0}.nav-item-link,.transparent-button{background-color:transparent}.abp-side-nav{width:100%;background-color:#17a2b8;color:#fff;text-align:left}.nav-item-group,.nav-item-group-child{list-style-type:none;line-height:2.5;padding-left:1px;padding-top:1px;padding-bottom:1px}.nav-item{padding-left:1px;padding-top:1px;padding-bottom:1px;border-bottom-style:groove;border-bottom-color:#fff}.nav-item-child{padding-left:2px;border-bottom-color:transparent!important}.nav-item-link{width:100%;text-align:left;color:#fff}.nav-item-link .nav-item-icon{float:right;padding-right:1px!important;margin-right:0!important;vertical-align:central}"]
            }]
    }], function () { return []; }, { show: [{
            type: Input
        }], navMenuModel: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AbpNavMenuComponent.prototype.show;
    /** @type {?} */
    AbpNavMenuComponent.prototype.navMenuModel;
}

var _a;
/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
class AbpNavMenuConstant {
}
//#region font awesome classes
AbpNavMenuConstant.font = (_a = class {
    },
    _a.caret_down = 'fa fa-caret-down',
    _a.caret_up = 'fa fa-caret-up',
    _a.caret_right = 'fa fa-caret-right',
    _a.caret_left = 'fa fa-caret-left',
    _a);
//#endregion font awesome classes
AbpNavMenuConstant.navConfigInjectKey = 'nav-menu-config';
if (false) {
    /** @type {?} */
    AbpNavMenuConstant.font;
    /** @type {?} */
    AbpNavMenuConstant.navConfigInjectKey;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class NavMenuItemComponent {
    //#endregion input properties
    //#region model properties
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} config
     */
    constructor(config) {
        this.config = config;
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    //#endregion component events
    //#region public functions/events assoaciated with UI elements
    /**
     * sub menu item click event
     * @param {?} menuItem
     * @param {?=} isChild
     * @return {?}
     */
    menuClick(menuItem, isChild = false) {
        this.expandCollapseSubNodes(this.node);
        if (menuItem.clickHandler) {
            menuItem.clickHandler(menuItem);
        }
    }
    /**
     * gets caret class
     * @param {?} menuItem
     * @return {?}
     */
    getCaretClass(menuItem) {
        if (menuItem.isExapand == true) {
            return this.config.expandStateIcon;
        }
        return this.config.collapseStateIcon;
    }
    /**
     * determines if child nodes are present
     * @param {?} menuItem
     * @return {?}
     */
    hasChildNodes(menuItem) {
        if (menuItem.childNodes && menuItem.childNodes.length > 0) {
            return true;
        }
        return false;
    }
    //#endregion public functions/events assoaciated with UI elements
    //#region private functions
    /**
     * toggles expand collapse
     * @private
     * @param {?} menuItem
     * @return {?}
     */
    expandCollapseSubNodes(menuItem) {
        menuItem.isExapand = !menuItem.isExapand;
    }
}
NavMenuItemComponent.ɵfac = function NavMenuItemComponent_Factory(t) { return new (t || NavMenuItemComponent)(ɵngcc0.ɵɵdirectiveInject(AbpNavMenuConstant.navConfigInjectKey)); };
NavMenuItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavMenuItemComponent, selectors: [["nav-menu-Item"]], inputs: { node: "node" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["type", "button", 1, "nav-item-link", 3, "name", "id", "click"], [3, "ngClass", 4, "ngIf"], [1, "nav-item-icon"], [3, "ngClass"], [1, "nav-item-group-child", 3, "id"], ["class", "nav-item-child", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "nav-item-child", 3, "ngClass"], [3, "node"]], template: function NavMenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NavMenuItemComponent_ng_container_0_Template, 7, 6, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.node != undefined && ctx.node != null);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgForOf, NavMenuItemComponent], styles: [_c0] });
/** @nocollapse */
NavMenuItemComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AbpNavMenuConstant.navConfigInjectKey,] }] }
];
NavMenuItemComponent.propDecorators = {
    node: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavMenuItemComponent, [{
        type: Component,
        args: [{
                selector: 'nav-menu-Item',
                template: "<ng-container *ngIf=\"node != undefined && node != null\">\r\n  <button type=\"button\"\r\n          name=\"a_olm_{{node.code}}\"\r\n          id=\"a_olm_{{node.code}}\"\r\n          class=\"nav-item-link\"\r\n          (click)=\"menuClick(node)\">\r\n    <i *ngIf=\"node.icon\"\r\n       [ngClass]=\"node.icon\">\r\n    </i>\r\n    {{node.displayText}} \r\n    <div class=\"nav-item-icon\">\r\n      <i [ngClass]=\"getCaretClass(node)\"\r\n         *ngIf=\"hasChildNodes(node)\">\r\n      </i>\r\n    </div>\r\n  </button>\r\n  <ng-container *ngIf=\"hasChildNodes(node) && node.isExapand\">\r\n\r\n    <ul id=\"ul_child_subMenu{{node.code}}\"\r\n        class=\"nav-item-group-child\">\r\n      <li [ngClass]=\"submenuItem.isActive ? 'active' : ''\"\r\n          class=\"nav-item-child\"\r\n          *ngFor=\"let submenuItem of node.childNodes\">\r\n        <nav-menu-Item [node]=\"submenuItem\"></nav-menu-Item>\r\n      </li>\r\n    </ul>\r\n\r\n  </ng-container>\r\n</ng-container>\r\n",
                styles: [".nav-item-link,.transparent-border,.transparent-button{border-style:solid;border-color:transparent}.abp-side-nav,.no-left-padding,.no-side-span{padding-left:0}.abp-side-nav,.no-right-padding,.no-side-span{padding-right:0}.abp-side-nav,.no-top-padding{padding-top:0}.nav-item-link,.transparent-button{background-color:transparent}.abp-side-nav{width:100%;background-color:#17a2b8;color:#fff;text-align:left}.nav-item-group,.nav-item-group-child{list-style-type:none;line-height:2.5;padding-left:1px;padding-top:1px;padding-bottom:1px}.nav-item{padding-left:1px;padding-top:1px;padding-bottom:1px;border-bottom-style:groove;border-bottom-color:#fff}.nav-item-child{padding-left:2px;border-bottom-color:transparent!important}.nav-item-link{width:100%;text-align:left;color:#fff}.nav-item-link .nav-item-icon{float:right;padding-right:1px!important;margin-right:0!important;vertical-align:central}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AbpNavMenuConstant.navConfigInjectKey]
            }] }]; }, { node: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    NavMenuItemComponent.prototype.node;
    /**
     * @type {?}
     * @private
     */
    NavMenuItemComponent.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AbpNavMenuModule {
    /**
     * @param {?=} config
     * @return {?}
     */
    static forRoot(config = null) {
        return (/** @type {?} */ ({
            ngModule: AbpNavMenuModule,
            providers: [
                { provide: AbpNavMenuConstant.navConfigInjectKey, useValue: config },
            ],
        }));
    }
}
AbpNavMenuModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpNavMenuModule });
AbpNavMenuModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpNavMenuModule_Factory(t) { return new (t || AbpNavMenuModule)(); }, imports: [[
            CommonModule,
            RouterModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpNavMenuModule, { declarations: function () { return [AbpNavMenuComponent, NavMenuItemComponent]; }, imports: function () { return [CommonModule,
        RouterModule]; }, exports: function () { return [AbpNavMenuComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpNavMenuModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                ],
                declarations: [
                    AbpNavMenuComponent,
                    NavMenuItemComponent
                ],
                exports: [
                    AbpNavMenuComponent
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpMenuItemModel, AbpNavMenuComponent, AbpNavMenuConstant, AbpNavMenuModel, AbpNavMenuModule, NavMenuItemComponent as ɵa };

//# sourceMappingURL=colibrium-abp-nav-menu.js.map